<template>
    <form-group
        v-bind="form_group_props"
    >
        <template v-slot:read_only><slot name="read_only"></slot></template>
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:hint><slot name="hint"></slot></template>
        <input-group
            v-bind="input_group_props"
            class="uk-width-1-1"
        >
            <div class="uk-form-icon uk-form-icon-flip lam-in-field-button uk-width-1-1">
                <a
                    href
                    :class="{'uk-icon-eye': !shown,'uk-icon-eye-slash': shown}"
                    class="uk-icon-hover" @click.prevent="toggle"
                ></a>
                <input
                    ref="field"
                    :id="identifier"
                    :type="standardized_type"
                    :name="name"
                    :value="value"
                    :placeholder="placeholder"
                    :aria-describedby="!!has_slot('hint')?`${identifier}-description`:false"
                    :disabled="disabled||!editable"
                    :autocomplete="autocomplete"
                    @focus="maybe_autoselect"
                    @keyup="keyup"
                    @blur="blur"
                    :class="{ [`uk-width-${width}`]: true, [`uk-text-${align}`]: true, [`uk-form-${size}`]: true }"
                    class="form-input"
                />
            </div>
        </input-group>
    </form-group>
</template>

<script>
import debounce from "lodash/debounce"

import is_nibnut_component from "../mixins/IsNibnutComponent"

import FormGroup from "./FormGroup"
import InputGroup from "./InputGroup"

let timer

export default {
    name: "FormPassword",
    mixins: [is_nibnut_component],
    components: {
        FormGroup,
        InputGroup
    },
    watch: {
        // editable: "maybe_focus_field"
    },
    methods: {
        focus_field () {
            this.$refs.field.focus()
            this.$refs.field.select()
        },
        maybe_focus_field () {
            if(this.editable) setTimeout(this.focus_field, 150)
        },
        maybe_autoselect () {
            if(this.autoSelect && this.showing) this.$refs.field.select()
        },
        keyup: debounce(function (event) {
            if(timer) {
                clearTimeout(timer)
                timer = null
            }
            timer = setTimeout(() => {
                this.hide()
            }, 7000)
            this.$emit("input", event.target.value, this.name)
        }, 300),
        blur (event) {
            const value = event.target.value
            this.$emit("input", value, this.name)
            this.$emit("blur", value, this.name) // can be useful for autofilled values... Use this to manually set your v-model's value
        },
        show () {
            if(!this.shown) {
                this.shown = true
                setTimeout(() => {
                    this.maybe_autoselect()
                }, 200)
                timer = setTimeout(() => {
                    this.hide()
                }, 7000)
            }
        },
        hide () {
            if(timer) {
                clearTimeout(timer)
                timer = null
            }
            if(this.shown) this.shown = false
        },
        toggle () {
            if(this.shown) this.hide()
            else this.show()
        }
    },
    computed: {
        form_group_props () {
            return {
                id: this.id,
                name: this.name,
                value: this.value,
                required: this.required,
                editable: this.editable,
                error: this.error,
                waiting: this.saving
            }
        },
        input_group_props () {
            return {
                glyph: this.glyph
            }
        },
        standardized_type () {
            return this.shown ? "text" : "password"
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: ""
        },
        width: {
            type: String,
            default: "1-1"
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal|large)$/i),
            default: "normal"
        },
        align: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(left|right|center)$/i),
            default: "left"
        },
        required: {
            type: Boolean,
            required: true
        },
        placeholder: {
            type: String,
            default: ""
        },
        autocomplete: {
            type: String,
            default: "new-password"
        },
        editable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        live: {
            type: Boolean,
            default: false
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            shown: false
        }
    }
}
</script>
